import { useEffect, useMemo, useState } from 'react';
import { CloudTheme } from 'src/vendor/orb-ui/themes/cloud/CloudTheme';
import { resolveOrbTheme } from 'src/vendor/orb-ui/themes/config';

import type { ResolvedCloudTheme } from 'src/vendor/orb-ui/themes/config';
import type { CompanionState } from './model';

export default function CloudOrb({ state, size = 80 }: { state: CompanionState; size?: number }) {
    const [visible, setVisible] = useState(!document.hidden);
    useEffect(() => {
        const change = () => setVisible(!document.hidden);
        document.addEventListener('visibilitychange', change);
        return () => document.removeEventListener('visibilitychange', change);
    }, []);
    const engaged = ['searching', 'found', 'thinking'].includes(state);
    const config = useMemo(
        () =>
            resolveOrbTheme({
                name: 'cloud',
                preset: 'calm',
                appearance: engaged
                    ? {
                          deepColor: '#103596',
                          upperColor: '#3478ff',
                          lowerColor: '#a7d2ff',
                          highlightColor: '#edf6ff',
                          launchColor: '#0044ff',
                          spinnerColor: '#b4dcff',
                      }
                    : {
                          deepColor: '#626262',
                          upperColor: '#999999',
                          lowerColor: '#cdcdcd',
                          highlightColor: '#ffffff',
                          launchColor: '#aaaaaa',
                          spinnerColor: '#e8e8e8',
                      },
                geometry: { diameterRatio: 0.88, listeningMinScale: 0.98, speakingMaxScale: 1.06 },
                motion: {
                    idleSpeed: 0.18,
                    listeningBaseSpeed: 0.65,
                    listeningSpeedRange: 0.25,
                    speakingBaseSpeed: 1.1,
                    speakingSpeedRange: 0.35,
                    entranceHoldMs: 0,
                    entranceGrowMs: 0,
                    entranceSettleMs: 0,
                },
            }) as ResolvedCloudTheme,
        [engaged]
    );
    return (
        <span
            className="lm-companion-orb"
            data-state={state}
            aria-hidden="true"
            style={{ width: size, height: size }}
        >
            {visible && (
                <CloudTheme
                    state={state === 'found' ? 'speaking' : engaged ? 'listening' : 'thinking'}
                    volume={state === 'found' ? 0.65 : 0.4}
                    size={size}
                    declaredSize={size}
                    config={config}
                    interactive={false}
                />
            )}
        </span>
    );
}
